import { render } from "./SearchView.vue?vue&type=template&id=3381b042&scoped=true"
import script from "./SearchView.js?vue&type=script&lang=js&external"
export * from "./SearchView.js?vue&type=script&lang=js&external"

import "./SearchView.vue?vue&type=style&index=0&id=3381b042&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3381b042"]])

export default __exports__